import { AccountsService } from 'base/accounts_service';
import React from 'react';

export const useReferralLink = ({
  accountsService,
  enabled,
}: {
  accountsService: AccountsService;
  enabled: boolean;
}) => {
  const [linkDataState, setLinkDataState] = React.useState<{
    loading: boolean;
    url: string | null;
    error: boolean;
  }>({ loading: false, url: null, error: false });

  React.useEffect(() => {
    if (
      enabled &&
      !linkDataState.url &&
      !linkDataState.loading &&
      !linkDataState.error
    ) {
      setLinkDataState({ loading: true, url: null, error: false });

      accountsService
        .getReferralLink()
        .then(({ url }) => {
          setLinkDataState({ loading: false, url, error: false });
        })
        .catch(() => {
          setLinkDataState({ loading: false, url: null, error: true });
        });
    }
  }, [
    accountsService,
    enabled,
    linkDataState.loading,
    linkDataState.url,
    linkDataState.error,
  ]);

  return linkDataState;
};
